import { Suspense, useEffect } from 'react'
import { SkeletonTheme } from 'react-loading-skeleton'
import { HelmetProvider } from 'react-helmet-async'
import { FullLoader } from 'ui'
import { AppRoutes } from 'pages/routes'
import { Modals } from 'features/common/modal/modals'
import Toasts from 'features/common/toasts/toasts'

import 'react-loading-skeleton/dist/skeleton.css'

const App = () => {
    useEffect(() => {
        const updateAppHeight = () => {
            document.documentElement.style.setProperty(
                '--app-height',
                `${window.innerHeight}px`
            )
        }

        updateAppHeight()
        window.addEventListener('resize', updateAppHeight)

        return () => {
            window.removeEventListener('resize', updateAppHeight)
        }
    }, [])

    return (
        <SkeletonTheme
            baseColor="rgba(0, 0, 0, .2)"
            highlightColor="rgba(0, 0, 0, .2)"
            inline
        >
            <Suspense fallback={<FullLoader />}>
                <HelmetProvider>
                    <AppRoutes />
                    <Modals />
                    <Toasts />
                </HelmetProvider>
            </Suspense>
        </SkeletonTheme>
    )
}

export default App
